export function siteUrl(link = '') {
    return process.env.REACT_APP_ENDPOINT + link;
}
export function coreAppUrl(link = '') {
    return process.env.REACT_APP_CORE_APP_URL + link;
}
